import React from 'react';
import useFetch from '../../hooks/useFetch';
import sampleimage from "../../assets/sample-image.png"

export default function FeaturedProperties() {
    const { data, loading, error } = useFetch("/hotels?featured=true");


    console.log(data)
    return (
        <div className='flex justify-between w-full max-w-5xl gap-5'>

            {loading ? <div className='flex'>
                <div style={{ borderTopColor: "transparent" }} className="w-8 h-8 border-4 border-blue-200 rounded-full animate-spin"></div>
                <p className='ml-2'>Loading..</p>
            </div>
                : (
                    <>
                        {data.map((item) => (
                            <div className="flex flex-col flex-1 gap-2" key={item._id}>

                                <img src={item.photos[0] || sampleimage}
                                    alt="" className="object-cover w-full h-60" />
                                <span className="font-bold text-slate-700">{item.name}</span>
                                <span className="font-light font-semibold text-slate-600">{item.city}</span>
                                <span className="font-medium">Starting from {item.cheapestPrice} ETB </span>
                                <div className="mr-2 font-bold text-white">
                                    <button className='p-1 bg-yellow-400 rounded-md'>{item.rating}</button>
                                    <span className='ml-2 font-thin text-slate-700'>Excellent</span>
                                </div>
                            </div>
                        ))}
                    </>
                )
            }
        </div >





    );
}
